import React from 'react'

import cx from 'classnames'
import s from './Checkbox.module.css'
import { CheckIcon } from 'components/common'

const Checkbox = ({ style, checked, onChange, className, disabled }) => {
  const checkboxClass = cx(s.checkbox, className, {
    [s.checkboxChecked]: checked,
    [s.checkboxDisabled]: disabled
  })

  return (
    <span className={checkboxClass} style={style}>
      <input
        type="checkbox"
        checked={checked}
        style={style}
        onChange={onChange}
        disabled={disabled}
      />
      <div className={s.checkboxInner}>
        <CheckIcon />
      </div>
    </span>
  )
}

export default Checkbox
